var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import config from '@/config';
import api from '@/shared/api';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export var WEEK_PLANNER_UNPLANNED_TASKS_PAGE_SIZE = 10;
export var useGetWeekPlannerUnplannedTasks = function (filters, enabled) {
    var _a;
    var intl = useIntl();
    var mainSelected = filters.mainSelected !== false;
    var subSelected = filters.subSelected !== false;
    var anyLevelSelected = mainSelected || subSelected;
    var taskLevel;
    if (mainSelected && !subSelected)
        taskLevel = 0;
    else if (!mainSelected && subSelected)
        taskLevel = 1;
    else
        taskLevel = undefined;
    var _m = filters.mainSelected, _s = filters.subSelected, wireFilters = __rest(filters, ["mainSelected", "subSelected"]);
    var _b = useInfiniteQuery([TaskQueryKey.WeekPlannerUnplannedTasks, filters], function (_a) {
        var _b = _a.pageParam, pageParam = _b === void 0 ? 0 : _b;
        return api.base
            .get("".concat(config.appUrls.tasks, "/api/WeekPlanner/UnplannedTasks"), {
            params: __assign(__assign({}, wireFilters), { taskLevel: taskLevel, page: pageParam, take: WEEK_PLANNER_UNPLANNED_TASKS_PAGE_SIZE }),
        })
            .then(function (res) { var _a; return (_a = res.data) !== null && _a !== void 0 ? _a : []; });
    }, {
        enabled: enabled && !!filters.userId && anyLevelSelected,
        getNextPageParam: function (lastPage, allPages) {
            return lastPage.length === WEEK_PLANNER_UNPLANNED_TASKS_PAGE_SIZE ? allPages.length : undefined;
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), data = _b.data, isLoading = _b.isLoading, isFetching = _b.isFetching, isFetchingNextPage = _b.isFetchingNextPage, error = _b.error, refetch = _b.refetch, fetchNextPage = _b.fetchNextPage, hasNextPage = _b.hasNextPage;
    var items = (_a = data === null || data === void 0 ? void 0 : data.pages.flat()) !== null && _a !== void 0 ? _a : [];
    return {
        items: items,
        error: error,
        isLoading: isLoading,
        isFetching: isFetching,
        isFetchingNextPage: isFetchingNextPage,
        refetch: refetch,
        fetchNextPage: fetchNextPage,
        hasNextPage: !!hasNextPage,
    };
};
